import type { CadPlanGroup, CadPlanId, WwwSsoUser } from '@onshape/www-inertia';

type SsoInfoResponse = {
  isReady: boolean;
  ssoInfo: SSOInfo | null;
};

/** type is mirrored on bundle */
type SSOInfo = {
  planGroup: CadPlanGroup;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  image: string | null;
  extraData: {
    industry?: string;
    persona?: string;
    jobTitleNormalized?: string;
    currentCADSystem?: string;
    productSkuAtSignup?: string;
    csmName?: string;
    csmEmail?: string;
    isEmailPreferencesSet?: boolean;
    isSubPremiumContent?: boolean;
    isSubNewsletter?: boolean;
    isSubEvents?: boolean;
    isSubBlogs?: boolean;
    productSku?: string;
    daysLeftInTrial?: string;
    numberOfExports?: string;
    numberOfImports?: string;
    stlImportsExports?: string;
    hasCompletedAnyTraining?: string;
    hasStartedAnyTraining?: string;
    uUsageTimeL30D?: string;
  };
  currentUserData: {
    activePlanId: CadPlanId; // active plan is different if using company provided plan
    activePlanGroup: CadPlanGroup;
    ownPlanId: CadPlanId; // purchased by the individual
    ownPlanGroup: CadPlanGroup;
    uid: string;
  };
};

const buildSsoInfoForHekate = ({ user }: { user: Ref<WwwSsoUser | null> }) => {
  if (!user.value) {
    return {
      isReady: false,
      ssoInfo: null,
    } as SsoInfoResponse;
  }

  const ssoInfo: SSOInfo = {
    planGroup: user.value?.planGroup || 'Other',
    name: user.value?.name || '',
    firstName: user.value?.firstName || '',
    lastName: user.value?.lastName || '',
    email: user.value?.email || '',
    image: user.value?.image || null,
    extraData: {
      industry: '',
      persona: '',
      jobTitleNormalized: user.value?.eloquaExtraData?.jobTitleNormalized || '',
      currentCADSystem: user.value?.eloquaExtraData?.currentCADSystem || '',
      productSkuAtSignup: user.value?.eloquaExtraData?.productSkuAtSignup || '',
      csmName: user.value?.eloquaExtraData?.csmName || '',
      csmEmail: user.value?.eloquaExtraData?.csmEmail || '',
      isEmailPreferencesSet: user.value?.eloquaExtraData?.isEmailPreferencesSet || false,
      isSubPremiumContent: user.value?.eloquaExtraData?.isSubPremiumContent || false,
      isSubNewsletter: user.value?.eloquaExtraData?.isSubNewsletter || false,
      isSubEvents: user.value?.eloquaExtraData?.isSubEvents || false,
      isSubBlogs: user.value?.eloquaExtraData?.isSubBlogs || false,
      productSku: user.value?.eloquaExtraData?.productSku || '',
      daysLeftInTrial:
        `${user.value?.cadPiiCurrentUserResponse?.activeTrialInfo?.trialDaysRemaining}` || '',
      numberOfExports: '',
      numberOfImports: '',
      stlImportsExports: '',
      hasCompletedAnyTraining: '',
      hasStartedAnyTraining: '',
      uUsageTimeL30D: `${user.value.eloquaExtraData?.uUsageTimeL30D}` || '0',
    },
    currentUserData: {
      activePlanId: user.value.cadPiiCurrentUserResponse?.activePlanId || 'FREE_2016',
      activePlanGroup: user.value.cadPiiCurrentUserResponse?.activePlanGroup || 'Other',
      ownPlanId: user.value.cadPiiCurrentUserResponse?.ownPlanId || 'FREE_2016',
      ownPlanGroup: user.value.cadPiiCurrentUserResponse?.ownPlanGroup || 'Other',
      uid: user.value.cadPiiCurrentUserResponse?.uid || '',
    },
  };

  const resp: SsoInfoResponse = {
    isReady: true,
    ssoInfo: ssoInfo,
  };

  return resp;
};

export default buildSsoInfoForHekate;
